// src/slices/post/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getPostsWebsite, getOnePostWebsite, createPost, updatePost, deletePost, togglePostStatus, getPostsByCategory, getTopViewedPosts } from "./thunk";

const initialState = { loading: {}, posts: [], topViewedPosts: [], categoryPosts: {}, post: null, error: null };

const postSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {
    clearPost: (state) => {
      state.post = null;
    }
  },

  extraReducers: (builder) => {
    builder

      // ================= GET ALL =================
      .addCase(getPostsWebsite.pending, (state) => {
        state.loading["all"] = true;
        state.error = null;
      })
      .addCase(getPostsWebsite.fulfilled, (state, action) => {
        state.loading["all"] = false;
        state.posts = action.payload?.data?.data || [];
        state.pagination = action.payload?.data?.responseDetails?.pagination || {};
        state.totalCount = action.payload?.data?.responseDetails?.filteredCount ?? (action.payload?.data?.responseDetails?.totalCount || 0);
      })
      .addCase(getPostsWebsite.rejected, (state, action) => {
        state.loading["all"] = false;
        state.error = action.payload;
      })
      // Get Top Viewed Posts
      .addCase(getTopViewedPosts.pending, (state) => {
        state.loading["topViewed"] = true;
        state.error = null;
      })

      .addCase(getTopViewedPosts.fulfilled, (state, action) => {
        state.loading["topViewed"] = false;
        state.topViewedPosts = action.payload?.data;
      })

      .addCase(getTopViewedPosts.rejected, (state, action) => {
        state.loading["topViewed"] = false;
        state.error = action.payload;
      })
      // ================= GET BY CATEGORY =================
      .addCase(getPostsByCategory.pending, (state, action) => {
        const id = action.meta.arg;
        state.loading[id] = true;
      })
      .addCase(getPostsByCategory.fulfilled, (state, action) => {
        const { categoryId, data } = action.payload || {};

        state.loading[categoryId] = false;
        state.categoryPosts[categoryId] = data;

      })
      .addCase(getPostsByCategory.rejected, (state, action) => {
        const id = action.meta.arg;
        state.loading[id] = false;
        state.error = action.payload;
      })

      // ================= GET ONE =================
      .addCase(getOnePostWebsite.pending, (state) => {
        state.loading["single"] = true;
      })
      .addCase(getOnePostWebsite.fulfilled, (state, action) => {
        state.loading["single"] = false;
        state.post = action.payload;
      })
      .addCase(getOnePostWebsite.rejected, (state, action) => {
        state.loading["single"] = false;
        state.error = action.payload;
      })

      // ================= CREATE =================
      .addCase(createPost.pending, (state) => {
        state.loading["create"] = true;
      })
      .addCase(createPost.fulfilled, (state, action) => {
        state.loading["create"] = false;
        state.posts.unshift(action.payload);
      })
      .addCase(createPost.rejected, (state, action) => {
        state.loading["create"] = false;
        state.error = action.payload;
      })

      // ================= UPDATE =================
      .addCase(updatePost.pending, (state) => {
        state.loading["update"] = true;
      })
      .addCase(updatePost.fulfilled, (state, action) => {
        state.loading["update"] = false;

        const index = state.posts.findIndex((item) => item._id === action.payload._id);

        if (index !== -1) {
          state.posts[index] = action.payload;
        }

        state.post = action.payload;
      })
      .addCase(updatePost.rejected, (state, action) => {
        state.loading["update"] = false;
        state.error = action.payload;
      })

      // ================= DELETE =================
      .addCase(deletePost.pending, (state) => {
        state.loading["delete"] = true;
      })
      .addCase(deletePost.fulfilled, (state, action) => {
        state.loading["delete"] = false;

        state.posts = state.posts.filter((item) => item._id !== action.payload);
      })
      .addCase(deletePost.rejected, (state, action) => {
        state.loading["delete"] = false;
        state.error = action.payload;
      })

      // ================= TOGGLE STATUS =================
      .addCase(togglePostStatus.pending, (state) => {
        state.loading["toggle"] = true;
      })
      .addCase(togglePostStatus.fulfilled, (state, action) => {
        state.loading["toggle"] = false;

        const index = state.posts.findIndex((item) => item._id === action.payload._id);

        if (index !== -1) {
          state.posts[index] = action.payload;
        }
      })
      .addCase(togglePostStatus.rejected, (state, action) => {
        state.loading["toggle"] = false;
        state.error = action.payload;
      });
  }
});

export const { clearPost } = postSlice.actions;
export default postSlice.reducer;
